import MxFormErrorMessage from "@rf-l2/form/MxFormErrorMessage";
import MxFormFieldController from "@rf-l2/form/MxFormFieldController";
import MxFormTextDateField, {
  MxFormTextDateFieldProps
} from "@rf-l2/form/text-fields/MxFormTextDateField";
interface MxFormL3TextDateFieldProps extends MxFormTextDateFieldProps {
  name: string;
  withreacthookform?: 1 | 0;
}
const MxFormL3TextDateField = (props: MxFormL3TextDateFieldProps) => {
  const { name, withreacthookform, ...rest } = props;
  return (
    <MxFormFieldController {...{ name, withreacthookform }}>
      <MxFormTextDateField label={props.label} {...rest} />
      <MxFormErrorMessage />
    </MxFormFieldController>
  );
};

export default MxFormL3TextDateField;
2;
